class FlashFactory {

  constructor($log, $rootScope) {
    this.$log = $log

    this.messageQueue = []
    this.currentMessage = ""

    $rootScope.$on("$routeChangeSuccess", this.popMessage.bind(this));
    $rootScope.$on("$stateChangeSuccess", this.popMessage.bind(this));

  }

  setMessage(message) {
    this.$log.debug("Pushing message: " + message)
    this.messageQueue.push(message);
  }

  popMessage() {
    this.currentMessage = this.messageQueue.shift()  || "";
    this.$log.debug("Popping message queue: " + this.currentMessage)
  }

}

FlashFactory.$inject = ['$log', '$rootScope' ]

export default FlashFactory
